import {GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE} from '@/services/global-event-listener.service';

class DatatableRowActionConfigurationHandlerService {

    public triggerRowActionConfiguration(
        actionConfiguration?: DisguiseDto.DTActionConfigurationUnion,
        inputConfiguration?: DisguiseDto.DTInputConfigurationDto
    ) {
        if (actionConfiguration) {
            const actionConfigurationType = actionConfiguration['@type'];
            if (actionConfigurationType) {
                switch (actionConfigurationType) {
                    case 'DTPropagateGlobalEventActionConfiguration': {
                        const castedPropagateGlobalEventActionConfiguration = actionConfiguration as
                            DisguiseDto.DTPropagateGlobalEventActionConfiguration;
                        for (const currentEvent of castedPropagateGlobalEventActionConfiguration.events || []) {
                            switch (currentEvent.type) {
                                case 'DTPropagateGlobalEventDto': {
                                    const castedPropagateGlobalEventDto =
                                        currentEvent as DisguiseDto.DTPropagateGlobalEventDto;
                                    this.propagateGlobalEvent(castedPropagateGlobalEventDto);
                                    break;
                                }
                                case 'DTOverrideInputConfigurationEventDto': {
                                    const event = currentEvent as DisguiseDto.DTOverrideInputConfigurationEventDto;

                                    if (event.overrideFilterColumns && inputConfiguration) {
                                        // if valid config is present
                                        // 1. reset search, advanced search, sort, sortrank
                                        for (const currentColumnFilter of inputConfiguration.columns || []) {
                                            currentColumnFilter.searchValue = undefined;
                                            currentColumnFilter.sort = undefined;
                                            currentColumnFilter.sortRank = undefined;
                                            currentColumnFilter.searchValues = undefined;
                                        }
                                        for (const columnConfig of event.overrideFilterColumns) {
                                            for (const currentColumnFilter of inputConfiguration.columns || []) {
                                                // 2. if column is found by key, then apply sort, sortrank, searchvalue
                                                if (currentColumnFilter.key === columnConfig.key) {
                                                    currentColumnFilter.sort = columnConfig.sort;
                                                    currentColumnFilter.sortRank = columnConfig.sortRank;
                                                    currentColumnFilter.searchValue = columnConfig.searchValue;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        break;
                    }
                    default: {
                        break;
                    }
                }
            }
        }
    }

    public propagateGlobalEvent(eventCfg: DisguiseDto.DTPropagateGlobalEventDto) {
        if (eventCfg.event !== undefined
            && eventCfg.globalEventAction !== undefined) {
            GLOBAL_EVENT_LISTENER_SERVICE_INSTANCE.notifyListener(
                eventCfg.event,
                eventCfg.globalEventAction
            );
        } else {
            throw new Error('event or globalEventAction undefined!');
        }
    }
}

const DATATABLE_ROW_ACTION_CONFIGURATION_HANDLER_SERVICE_INSTANCE = new DatatableRowActionConfigurationHandlerService();

export {DATATABLE_ROW_ACTION_CONFIGURATION_HANDLER_SERVICE_INSTANCE};
